module.exports = __webpack_public_path__ + "1ad50fdc41fc38aaafce2dc095a1c2a7.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Poppins-Light.otf
// module id = 876
// module chunks = 0